import React from 'react';
import PravirPhoto from './pictures/PravirPhoto.jpg';
import './AboutMe.css';

function AboutMe() {
  return (
    <div className="about-me">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-name">Pravir Chugh</h1>
            <p className="hero-statement">
              I care about building intelligent systems that are reliable by design and adaptive by nature.
            </p>
            <p className="hero-tagline">AI/ML Engineer · SAP · UCLA</p>
            <div className="hero-buttons">
              <a 
                href="https://www.linkedin.com/in/pravirchugh" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-button linkedin-button"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                LinkedIn
              </a>
              <a 
                href="https://github.com/pravirchugh" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-button github-button"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
                GitHub
              </a>
            </div>
          </div>
          <div className="hero-image">
            <img src={PravirPhoto} alt="Pravir Chugh" className="portrait-photo" />
          </div>
        </div>
      </section>

      {/* About Content */}
      <section className="about-content">
        <div className="about-section">
          <h2 className="section-title">My Story</h2>
          <div className="about-text">
            <p>
              My engineering journey is a personal one.
            </p>
            
            <p>
              Three weeks before I was supposed to leave Seattle for UCLA, I lost my father in a tragic incident. 
              He was the person who first made engineering feel exciting, meaningful, and full of possibility. 
              I was eighteen and facing the hardest moment of my life, while everyone encouraged me to delay school 
              for a year and stay home.
            </p>

            <p>
              But I pressed on. Not because it was easy, but because I knew who my father wanted me to become.
            </p>

            <p>
              That decision defined everything that came next. It taught me resilience, self-direction, and 
              how to keep moving forward even when circumstances are far from ideal. It also shaped my engineering 
              philosophy: build with intention, build things that last, and build systems that hold up under pressure.
            </p>

            <p>
              Since then, my work has focused on <b>AI systems and infrastructure</b>. Not just models, but 
              orchestration, pipelines, deployment layers, and the reliability guarantees that make intelligent 
              systems real, usable, and scalable. I am especially interested in the intersection of 
              <b> AI, distributed computing, and high-performance infrastructure</b>, where every engineering 
              decision compounds into meaningful capability.
            </p>

            <p>
              Over the next year, I’m looking for opportunities to help build the next generation of AI compute: 
              systems that accelerate how models are trained, deployed, and used at scale. I'm drawn to roles where 
              the engineering challenges are difficult, the performance stakes are high, and the impact lasts.
            </p>

            <p>
              If you’re learning, building, or pushing yourself forward wherever you are in your journey, 
              I’d be happy to connect.
            </p>
          </div>


          <div className="about-interests">
            <h3 className="interests-title">Interests</h3>
            <ul className="interests-list">
              <li>Software Development</li>
              <li>Artificial Intelligence</li>
              <li>Large-Scale Systems</li>
              <li>Cybersecurity</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutMe;
